<template>
  <b-row v-if="parentPath && path">
    <b-col md="12">
      <b-card
        v-tooltip="uniToolTipTranslation('S940', 'en-US')"
        class="card-panel"
        :header="uniTranslation('S940')"
        style="height:100%; margin-bottom: 0px !important"
      >
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <div>
              <UnidataEditor :parent-path="path" :name="'.totalCapacity'"></UnidataEditor>
            </div>
            <div>
              <UnidataEditor :parent-path="path" :name="'.sensibleCapacity'"></UnidataEditor>
            </div>
          </div>
          <div class="col-xl-6 col-lg-12">
            <div>
              <UnidataEditor :parent-path="path" :name="'.globalFactor'"></UnidataEditor>
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import UnidataEditor from "../unidata/UnidataEditor";
import { mapGetters } from "vuex";
// import { Select, Option, Collapse, CollapseItem } from "element-ui";
// import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    UnidataEditor /*,
    "el-select": Select,
    "el-option": Option,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"])
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  mounted: function() {
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    // var that = this;
  },
  methods: {}
};
</script>

<style lang="scss"></style>
